<template>
  <div class="page-wrapper">
    <div class="discard-review">
      <div class="content">
        <h4>
          Discard Review:
          {{ discardClient.clientId }}
        </h4>
        <textInput
          class="client-input"
          label="Client"
          :value="discardClient.clientId"
          width="300px"
          disabled
        />
        <commitData
          @setIsFormValid="setIsFormValid"
          @setTitle="setTitle"
          @setDetails="setDetails"
        />
        <updatedValuesSummary :updatedValues="allChanges" />
      </div>
    </div>
    <bottomBar>
      <qvoButton text @click="cancel">Cancel</qvoButton>
      <qvoButton :disabled="disableDiscardButton" @click="openConfirmation"> Discard </qvoButton>
    </bottomBar>
    <discardConfirmation
      v-model="showConfirmation"
      @closeModal="closeConfirmation"
    />
  </div>
</template>
  
  <script>
import { mapGetters } from "vuex";
import merge from "lodash/merge";
import reduce from "lodash/reduce";

import bottomBar from "@/components/bottom-bar";
import commitData from "@/components/commit-data";
import qvoButton from "@/qux-common/qux22/components/molecules/button";
import textInput from "@/qux-common/qux22/components/molecules/input";
import updatedValuesSummary from "@/components/updated-values-summary";
import discardConfirmation from "./discard-confirmation";

export default {
  name: "PromoteReview",
  components: {
    bottomBar,
    commitData,
    qvoButton,
    textInput,
    updatedValuesSummary,
    discardConfirmation,
  },
  data() {
    return {
      step: 1,
      showConfirmation: false,
      restoreVersion: '',
      changeTitle: '',
      changeDetails: '',
      isFormValid: false
    };
  },
  computed: {
    disableDiscardButton() {
      return this.pendingCallList.includes("/client/change/list") || this.isFormValid == false;
    },
    discardClient() {
      return this.getDiscardClient();
    },
    lastPromotedChange() {
      // find the list of changes since the last one that has a promotion tag
      const changeList = this.changeList;
      const lastPromotedChange = changeList.findIndex(
        (change) => !!change.PromotionTag
      );
      return lastPromotedChange;
    },
    allChanges() {
      const changeList = this.changeList;
      const lastPromotedChange = this.lastPromotedChange;

      const currentChanges =
        lastPromotedChange !== -1
          ? changeList.slice(0, lastPromotedChange)
          : [...changeList];

      const mergedChanges = reduce(
        currentChanges.reverse(),
        (acc, obj) => {
          return merge(acc, obj.Changes);
        },
        {}
      );

      return mergedChanges;
    },
    ...mapGetters({
      changeList: "getChangeList",
      discardClient: "getDiscardClient",
      pendingCallList: "getPendingCallList"
    }),
  },
  methods: {
    setIsFormValid(value){
      this.isFormValid = value;
    },
    setTitle(title){
      this.changeTitle = title;
    },
    setDetails(details){
      this.changeDetails = details;
    },
    getChangeList() {
      this.$store.dispatch("changeList", {
        ClientId: this.discardClient.clientId,
      });
    },
    cancel() {
      this.$router.push("/clients");
    },
    openConfirmation() {
      const lastPromotedChange = this.changeList[this.lastPromotedChange];
      this.discardClient.version = lastPromotedChange.Version;
      this.discardClient.changeDetails = this.changeDetails;
      this.discardClient.changeTitle = 'Discard Changes: ' + this.changeTitle;
      this.$store.dispatch("setDiscardClient", this.discardClient);
      this.showConfirmation = true;
    },
    closeConfirmation() {
      this.showConfirmation = false;
    },
  },
  mounted() {
    this.getChangeList();
  }
};
</script>
  
<style lang="scss" scoped>
.page-wrapper {
  height: calc(100vh - $header-height);
}
.discard-review {
  height: calc(100% - 74px);
  overflow: auto;
}
.content {
  padding: $qvo-spacing-24;
  max-width: 960px;
  margin: auto;
  h4 {
    padding-bottom: 12px;
  }
  .client-input {
    margin-bottom: $qvo-spacing-24;
  }
}
</style>